import singleWheelWeeder from "../Images/Products/single-wheel-weeder-DMe8vlxw.png";
import electricConoWeeder from "../Images/Products/electric-cono-weeder-DJ93mu3z.png";
import electricConoGallery2 from "../Images/client/products/electric-cono-weeder-gallery-2.jpg";
import electricConoGallery3 from "../Images/client/products/electric-cono-weeder-gallery-3.jpg";
import electricConoGallery4 from "../Images/client/products/electric-cono-weeder-gallery-4.jpg";
import poultryRakingMachine from "../Images/Products/poultry-raking-machine-Dgb_c5fi.jpg";
import poultryGallery1 from "../Images/client/products/poultry-raking-machine-gallery-1.jpg";
import poultryGallery3 from "../Images/client/products/poultry-raking-machine-gallery-3.jpg";
import poultryGallery4 from "../Images/client/products/poultry-raking-machine-gallery-4.jpg";
import trolleyBrushCutter from "../Images/Products/trolley-brush-cutter-DH8BO9cx.png";
import trolleyGallery4 from "../Images/client/products/trolley-brush-cutter-gallery-4.jpg";
import sidePackBrushCutter from "../Images/Products/side-pack-brush-cutter-DU1jEQJ_.png";
import sidePackGallery2 from "../Images/client/products/side-pack-brush-cutter-gallery-2.png";
import sidePackGallery3 from "../Images/client/products/side-pack-brush-cutter-gallery-3.jpg";
import farmerPlantationDemo from "../Images/client/field/farmer-plantation-demo.jpg";
import eTrolley from "../Images/Products/e-trolley-CmdOXSIH.png";
import eTrolleyGallery2 from "../Images/client/products/e-trolley-gallery-2.jpg";
import eTrolleyGallery3 from "../Images/client/products/e-trolley-gallery-3.jpg";
import eTrolleyGallery4 from "../Images/client/products/e-trolley-gallery-4.jpg";
import paddyThresher from "../Images/Products/paddy-thresher-CzFEBY2n.png";
import paddyThresherGallery2 from "../Images/client/products/paddy-thresher-gallery-2.jpg";
import singleWheelField1 from "../Images/client/products/single-wheel-field-1.jpg";
import singleWheelField2 from "../Images/client/products/single-wheel-field-2.jpeg";
import singleWheelField3 from "../Images/client/products/single-wheel-field-3.jpeg";
import poultryField1 from "../Images/client/products/poultry-raker-field-1.jpeg";
import poultryField2 from "../Images/client/products/poultry-raker-field-2.jpg";
import trolleyField1 from "../Images/client/products/trolley-brush-cutter-field-1.jpg";
import trolleyField2 from "../Images/client/products/trolley-brush-cutter-field-2.jpeg";

const source = {
  website: "client Website Content",
  existing: "existing approved site data",
  audit: "SNB/client asset audit",
};

const commonBenefits = [
  "Simple, safe, effortless operation",
  "Chemical-free, healthier crops",
  "Avoid Weedicides, Save Soil",
  "Low Running Cost, No Fuel",
  "Sustainable, eco-friendly farming",
];

export const products = [
  {
    id: 1,
    slug: "single-wheel-weeder",
    aliases: ["single-wheel"],
    title: "Single Wheel Weeder",
    eyebrow: "Inter-row weeding",
    desc: "A lightweight, efficient single-wheel weeder designed for inter-row weeding in row crops.",
    summary: "Battery-operated weeding and intercultivation support for row crops such as maize, soybean, groundnut and vegetables.",
    imageAlt: "Single Wheel Weeder machine product image",
    pic: [singleWheelWeeder, singleWheelField1, singleWheelField2, singleWheelField3],
    gallery: [
      { src: singleWheelWeeder, alt: "Single Wheel Weeder machine product image", source: source.existing, fit: "contain" },
      { src: singleWheelField1, alt: "Single Wheel Weeder being operated in a crop field", source: source.audit },
      { src: singleWheelField2, alt: "Single Wheel Weeder used between crop rows", source: source.audit },
      { src: singleWheelField3, alt: "Single Wheel Weeder in a cultivated field", source: source.audit },
    ],
    specs: [
      { label: "Motor Power", value: "2 HP", source: source.website },
      { label: "Attachments", value: "Blades, Variable Ridger", source: source.website },
      { label: "Crops", value: "Maize, Soybean, Groundnut, Vegetables, etc", source: source.website },
      { label: "Row Space", value: "12 inches to 18 inches", source: source.website },
      { label: "Battery Capacity", value: "48V 20AH", source: source.website },
    ],
    spec: {
      Motor: "2 HP",
      "Battery Capacity": "48V 20AH",
    },
    highlights: ["2 HP motor", "48V 20AH battery", "12–18 inch row spacing"],
    benefits: commonBenefits,
    videos: [
      { id: "3-QyY33c-Ic", title: "Single Wheel Weeder video 1", source: source.existing },
      { id: "Rat-pH7Ku2Q", title: "Single Wheel Weeder video 2", source: source.existing },
    ],
    yId: ["3-QyY33c-Ic", "Rat-pH7Ku2Q"],
    contentGaps: ["Confirm whether any additional crop-specific benefits should be shown beyond the supplied benefit list."],
  },
  {
    id: 2,
    slug: "paddy-weeder",
    aliases: ["electric-cono-weeder"],
    title: "Electric Cono Weeder (Paddy Weeder)",
    eyebrow: "Paddy weeding",
    desc: "Battery-powered cono weeder designed specifically for paddy fields.",
    summary: "A paddy-focused battery weeder for transplanted or SRI paddy where row spacing is suitable.",
    imageAlt: "Electric Cono Weeder machine product image",
    pic: [electricConoWeeder, electricConoGallery2, electricConoGallery3, electricConoGallery4],
    gallery: [
      { src: electricConoWeeder, alt: "Electric Cono Weeder machine product image", source: source.existing, fit: "contain" },
      { src: electricConoGallery2, alt: "Electric Cono Weeder being operated in a paddy field", source: source.audit, fit: "contain" },
      { src: electricConoGallery3, alt: "Electric Cono Weeder field demonstration in paddy", source: source.audit, fit: "contain" },
      { src: electricConoGallery4, alt: "Electric Cono Weeder working between paddy rows", source: source.audit, fit: "contain" },
    ],
    specs: [
      { label: "Motor Power", value: "1 HP", source: source.website },
      { label: "Attachments", value: "Weeder Blades", source: source.website },
      { label: "Crops", value: "Transplanted or SRI Paddy", source: source.website },
      { label: "Row Space", value: "6 inches to 12 inches", source: source.website },
      { label: "Battery Capacity", value: "48V 15AH", source: source.website },
    ],
    spec: {
      Motor: "1 HP",
      "Battery Capacity": "48V 15AH",
    },
    highlights: ["1 HP motor", "48V 15AH battery", "6–12 inch row spacing"],
    benefits: commonBenefits,
    videos: [
      { id: "oRZ_8-8BeDY", title: "Electric Cono Weeder video 1", source: source.existing },
      { id: "106xkiN48e4", title: "Electric Cono Weeder video 2", source: source.existing },
    ],
    yId: ["oRZ_8-8BeDY", "106xkiN48e4"],
    contentGaps: [
      "Confirm whether the paddy field-use photos in the SNB library belong to Electric Cono Weeder or another paddy product.",
    ],
  },
  {
    id: 3,
    slug: "poultry-raking-machine",
    title: "Poultry Raking Machine",
    eyebrow: "Poultry litter raking",
    desc: "Automated poultry litter raking machine for efficient poultry house management.",
    summary: "A battery-operated poultry raking machine for everyday poultry shed floor management.",
    imageAlt: "Poultry Raking Machine product image",
    pic: [poultryGallery1, poultryField1, poultryGallery3, poultryGallery4],
    gallery: [
      { src: poultryGallery1, alt: "Poultry Raking Machine product image", source: source.audit, fit: "contain" },
      { src: poultryField1, alt: "Poultry Raking Machine being used inside a poultry shed", source: source.audit },
      { src: poultryGallery3, alt: "Poultry Raking Machine in poultry shed use", source: source.audit },
      { src: poultryGallery4, alt: "Poultry Raking Machine product view", source: source.audit, fit: "contain" },
    ],
    specs: [
      { label: "Motor", value: "0.5 HP", source: source.website },
      { label: "Attachments", value: "Raking Attachments", source: source.website },
      { label: "Shed type", value: "Open shed, EC Shed", source: source.website },
      { label: "Flooring", value: "All kinds of flooring", source: source.website },
      { label: "Battery Capacity", value: "48V 10AH", source: source.website },
    ],
    spec: {
      Motor: "0.5 HP",
      "Battery Capacity": "48V 10AH",
    },
    highlights: ["0.5 HP motor", "Raking attachments", "Poultry shed use"],
    benefits: commonBenefits,
    videos: [
      { id: "whubCxXBEQk", title: "Poultry Raking Machine video 1", source: source.existing },
      { id: "4zGTpkQTdhQ", title: "Poultry Raking Machine video 2", source: source.existing },
    ],
    yId: ["whubCxXBEQk", "4zGTpkQTdhQ"],
    contentGaps: [],
  },
  {
    id: 4,
    slug: "trolley-brush-cutter",
    title: "Trolley Brush Cutter",
    eyebrow: "Brush cutting",
    desc: "Heavy-duty brush cutter mounted on a wheeled trolley for comfortable working.",
    summary: "A wheeled brush cutter format for plantation and horticultural crop settings.",
    imageAlt: "Trolley Brush Cutter product image",
    pic: [trolleyBrushCutter, trolleyField1, trolleyField2, trolleyGallery4],
    gallery: [
      { src: trolleyBrushCutter, alt: "Trolley Brush Cutter product image", source: source.existing, fit: "contain" },
      { src: trolleyField1, alt: "Trolley Brush Cutter being demonstrated in a plantation", source: source.audit },
      { src: trolleyField2, alt: "Trolley Brush Cutter being operated in field conditions", source: source.audit, position: "50% 68%" },
      { src: trolleyGallery4, alt: "Trolley Brush Cutter in field use", source: source.audit },
    ],
    specs: [
      { label: "Motor", value: "2 HP", source: source.website },
      { label: "Attachments", value: "Rope head, Blade, Tiller", source: source.website },
      { label: "Crops", value: "Arecanut, Coconut, Fruits, Plantation", source: source.website },
      { label: "Type", value: "Trolley Mount", source: source.website },
      { label: "Battery Capacity", value: "48V 20AH", source: source.website },
    ],
    spec: {
      Motor: "2 HP",
      "Battery Capacity": "48V 20AH",
    },
    highlights: ["2 HP motor", "48V 20AH battery", "Trolley mount"],
    benefits: commonBenefits,
    videos: [
      { id: "44khpJEHba8", title: "Trolley Brush Cutter video 1", source: source.existing },
      { id: "k5wezgmEqmY", title: "Trolley Brush Cutter video 2", source: source.existing },
    ],
    yId: ["44khpJEHba8", "k5wezgmEqmY"],
    contentGaps: [],
  },
  {
    id: 5,
    slug: "side-pack-brush-cutter",
    title: "Side pack Brush Cutter",
    eyebrow: "Side-mounted cutting",
    desc: "Ergonomic side-mounted brush cutter that distributes weight evenly.",
    summary: "A side-pack brush cutter for plantation and horticultural applications.",
    imageAlt: "Side Pack Brush Cutter product image",
    pic: [sidePackBrushCutter, farmerPlantationDemo, sidePackGallery2, sidePackGallery3],
    gallery: [
      { src: sidePackBrushCutter, alt: "Side Pack Brush Cutter product image", source: source.existing, fit: "contain" },
      { src: farmerPlantationDemo, alt: "Side Pack Brush Cutter plantation field use", source: source.audit, position: "50% 70%" },
      { src: sidePackGallery2, alt: "Side Pack Brush Cutter product view", source: source.audit, fit: "contain" },
      { src: sidePackGallery3, alt: "Side Pack Brush Cutter in field use", source: source.audit },
    ],
    specs: [
      { label: "Motor", value: "1 HP", source: source.website },
      { label: "Attachments", value: "Rope head, Blades", source: source.website },
      { label: "Crops", value: "Arecanut, Coconut, Fruits, Plantation", source: source.website },
      { label: "Type", value: "Sidepack Machine, Backpack Battery", source: source.website },
      { label: "Battery Capacity", value: "48V 15AH", source: source.website },
    ],
    spec: {
      Motor: "1 HP",
      "Battery Capacity": "48V 15AH",
    },
    highlights: ["1 HP motor", "48V 15AH battery", "Sidepack machine"],
    benefits: commonBenefits,
    videos: [
      { id: "SYMBoGr60_Y", title: "Side Pack Brush Cutter video", source: source.existing },
    ],
    yId: ["SYMBoGr60_Y"],
    contentGaps: [
      "Provide or confirm field-use photos; the audit found likely sidepack media but not enough support to label it confidently.",
    ],
  },
  {
    id: 6,
    slug: "e-trolley",
    title: "e-Trolley",
    eyebrow: "Farm transport",
    desc: "Electric-powered utility trolley for farm transport.",
    summary: "An electric trolley for moving farm materials across plantation and field contexts.",
    imageAlt: "e-Trolley product image",
    pic: [eTrolley, eTrolleyGallery2, eTrolleyGallery3, eTrolleyGallery4],
    gallery: [
      { src: eTrolley, alt: "e-Trolley product image", source: source.existing, fit: "contain" },
      { src: eTrolleyGallery2, alt: "e-Trolley in field use", source: source.audit, position: "50% 70%" },
      { src: eTrolleyGallery3, alt: "e-Trolley carrying farm materials", source: source.audit },
      { src: eTrolleyGallery4, alt: "e-Trolley product view", source: source.audit },
    ],
    specs: [
      { label: "Motor", value: "2 HP", source: source.website },
      { label: "Crops", value: "Arecanut, Coconut, Fruits, Plantation", source: source.website },
      { label: "Load Capacity", value: "400-500 kg", source: source.website },
      { label: "Battery Capacity", value: "48V 20AH", source: source.website },
    ],
    spec: {
      Motor: "2 HP",
      "Battery Capacity": "48V 20AH",
    },
    highlights: ["2 HP motor", "400-500 kg load capacity", "48V 20AH battery"],
    benefits: commonBenefits,
    videos: [
      { id: "GovVmOdi0zo", title: "e-Trolley video", source: source.existing },
    ],
    yId: ["GovVmOdi0zo"],
    contentGaps: ["Provide or confirm real-use photos for e-Trolley; the SNB audit found catalog media only."],
  },
  {
    id: 7,
    slug: "paddy-thresher",
    title: "Paddy Thresher",
    eyebrow: "Paddy threshing",
    desc: "Paddy threshing machine that separates grain from the stalk.",
    summary: "A paddy threshing machine presented with only currently supported specifications.",
    imageAlt: "Paddy Thresher product image",
    pic: [paddyThresher, paddyThresherGallery2],
    gallery: [
      { src: paddyThresher, alt: "Paddy Thresher product image", source: source.existing, fit: "contain" },
      { src: paddyThresherGallery2, alt: "Paddy Thresher product view", source: source.audit, fit: "contain" },
    ],
    disableGalleryPlaceholders: true,
    specs: [
      { label: "Motor", value: "2 HP", source: source.website },
      { label: "Energy Source", value: "Battery/ Electric Option", source: source.website },
      { label: "Crops", value: "Harvested Paddy", source: source.website },
      { label: "Capacity", value: "0.5 acre/ hour", source: source.website },
      { label: "Battery Capacity", value: "48V 20AH", source: source.website },
    ],
    spec: {
      Motor: "2 HP",
      "Battery Capacity": "48V 20AH",
    },
    highlights: ["2 HP motor", "Battery/ Electric Option", "0.5 acre/ hour capacity"],
    benefits: commonBenefits,
    videos: [],
    yId: [],
    contentGaps: [
      "Provide product videos.",
      "Provide or confirm real-use photos; the SNB audit found catalog media only.",
    ],
  },
];

export function getProductById(productId) {
  return products.find((product) => String(product.id) === String(productId) || product.slug === productId || product.aliases?.includes(productId));
}
